import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postAuthInfoUpload = async ({ dispatch, rootGetters }, { attachment, saveMode }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const hubTenantInfo = await stbApi.postAuthInfoUpload(attachment, saveMode);

  if (saveMode === 'save') {
    await dispatch('getHubTenantsList');
  }

  return hubTenantInfo;
};
